import React from 'react';
import Dropzone from 'react-dropzone';
import { translate } from 'react-i18next';
import { Thumbnail } from 'react-bootstrap';
import defaultImage from '../../assets/images/default_image.png';


export class DropableThumbnail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.image,
      isValid: true,
      isDirty: false,
    };
  }

  getFieldState() {
    return {
      value: this.state.value,
      isValid: this.state.isValid,
      isDirty: this.state.isDirty,
    };
  }

  getImage(image) {
    let imageUrl;
    if (image instanceof File) {
      imageUrl = image.preview;
    } else {
      imageUrl = image;
    }
    return imageUrl || defaultImage;
  }

  onDrop(files) {
    const { id, onChange } = this.props;
    const image = files[0];

    this.setState({ value: image, isDirty: true }, () => {
      if (onChange) {
        onChange({ target: { value: image } }, id);
      }
    });
  }

  render() {
    const { value } = this.state;
    const { t } = this.props;
    return (
      <div>
        <Thumbnail src={this.getImage(value)} alt="400x400">
          <p>
            {t('drop zone suggestion')}
          </p>
        </Thumbnail>
        <Dropzone
          onDrop={files => this.onDrop(files)}
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
          }}
        />
      </div>
    );
  }
}
export default translate('translations', { withRef: true })(DropableThumbnail);



// WEBPACK FOOTER //
// ./src/components/thumbnail/DropableThumbnail.js